import React from 'react';

import * as dates from 'react-big-calendar/lib/utils/dates';

import { navigate } from 'react-big-calendar/lib/utils/constants';
import CustomTimeGrid from './CustomTimeGrid';

export default class CustomMonthView extends React.Component {
  mergeVacationsData(prevData, nextData) {
    const { colleagues: prevColleagues } = prevData;
    const { colleagues: nextColleagues } = nextData;

    if (prevColleagues && nextColleagues) {
      let newData = [...prevColleagues];
      nextColleagues.forEach((e) => {
        const colleagueIndex = newData.findIndex((el) => +e.user.id === +el.user.id);
        if (colleagueIndex !== -1) {
          newData = [
            ...newData.slice(0, colleagueIndex),
            ...newData.slice(colleagueIndex + 1),
            {
              ...newData[colleagueIndex],
              leaverequestSet: [
                ...newData[colleagueIndex].leaverequestSet,
                ...e.leaverequestSet.filter(
                  (event) => newData[colleagueIndex].leaverequestSet.findIndex((ev) => +event.id === +ev.id) === -1
                ),
              ],
            },
          ];
        }
      });
      return newData;
    }
    return [];
  }

  componentDidUpdate(prevProps) {
    const { refetch, variables } = this.props;
    if (
      Object.keys(variables).length &&
      (prevProps.variables.endDate !== this.props.variables.endDate ||
        prevProps.variables.startDate !== this.props.variables.startDate)
    ) {
      refetch(variables);
    }
  }

  render() {
    let { date, range, ...props } = this.props;

    return <CustomTimeGrid {...props} range={range} eventOffset={15} className={'month-view'} />;
  }
}

CustomMonthView.range = (date) => {
  let start = dates.startOf(date, 'month');
  let end = dates.endOf(date, 'month');

  let current = start;
  let range = [];

  while (dates.lte(current, end, 'day')) {
    range.push(current);
    current = dates.add(current, 1, 'day');
  }

  return range;
};

CustomMonthView.navigate = (date, action) => {
  switch (action) {
    case navigate.PREVIOUS:
      return dates.add(date, -1, 'month');

    case navigate.NEXT:
      return dates.add(date, 1, 'month');

    default:
      return date;
  }
};

CustomMonthView.title = (date) => (
  <div className="toolbar__label">
    <div className="label-title">{date.toLocaleString('default', { month: 'long' })}</div>
    <div className="label-text">{date.getFullYear()}</div>
  </div>
);
